import * as React from 'react'
import { ValueProps as SelectorValueProps } from '../../LogPointsSelector/LogPointsSelector'
import { EventProps as SelectorEventProps } from '../../LogPointsSelector/LogPointsSelector'
import { LogPointsSelector } from '../../LogPointsSelector/LogPointsSelector'

export type ValueProps = SelectorValueProps

export type EventProps = SelectorEventProps

export type Props = ValueProps & EventProps

const baseClassName = 'log-points-header'

export const LogPointsHeader = (props: Props) => {
  const className = props.className ? `${baseClassName} ${props.className}` : baseClassName
  const selectorProps = {...props, className}

  return <LogPointsSelector {...selectorProps}/>
}
